// $('.navigation-mobile > nav.main-navigation').click(function() {
// //
//   console.log('header clicked')
//   $('body').removeClass('scroll-locked');
//   $('header.main-header').removeClass('mobile-navigation-open');
//   $(' nav.main-navigation').removeClass('visible');
//   $('div.navigation-toggle > button').removeClass('active');
// });



$(function(){
  var wishList_text = $(".giftreggie-pdp-wishlist-cta--button").text();
  $(".giftreggie-wishlist").html();
  $(".giftreggie-pdp-registry-cta--button").click(function(e){
    var chkUser = $("#chkUser").val();
    if(chkUser == 0){
       window.location.href = "/account/login";
       
    }
    
  });
  $(".giftreggie-registry").click(function(e){
    var chkUser = $(this).data("customer");
    if(chkUser == "true" || chkUser){
      // window.location.href = "/account/login";
      addGiftRegistry();
    }else{
       window.location.href = "/account/login";
    }
  });
  $(".giftreggie-wishlist").click(function(e){
    var chkUser = $(this).data("customer");
    if(chkUser == "true" || chkUser){
       $(".giftreggie-pdp-wishlist-cta--button").trigger("click");
       var wishList_text = $(".giftreggie-pdp-wishlist-cta--button").text();
      $(this).html(wishList_text);
    }else{
       window.location.href = "/account/login";
    }
  });




 /* var target = document.querySelector('.giftreggie-pdp-wishlist-cta--button')
  var observer = new MutationObserver(function(mutations) {
      var wishList_text = $(".giftreggie-pdp-wishlist-cta--button").text();
      $(".giftreggie-wishlist").html(wishList_text);
  });
  observer.observe(target, {
      attributes:    true,
      childList:     true,
      characterData: true
  });*/
  
  $(".template-product .productSelect").change(function(){
    var selectedOption = $(this).find("option:selected").data("optionid");
    //console.log(selectedOption);
    $("#"+selectedOption).parent().find("label").trigger("click");
  });
  $("#my_balance").click(function(){
    $("#bon-loyalty-btn").trigger("click");
  });
});

function resetSelect(obj){
  $(obj).each(function(){
      $(this).prop("selected",false);
  });
}

function openRegistryCollection(collection_url){
    $.get( collection_url, function( data ){
    $(".collection-data").html(data);
       $(".registery-modal-popup-wrapper").show();
       $(".modal-overlay").show();
    });
}

function getAllCustomerRegistries(){
  $.ajax({ url: 'https://ipcoop.genielab.uk/json/gift/registry',
   type: "GET",
   success: function (data) {
     //var resultData = JSON.stringify(data);
     console.log(JSON.parse(data.body).registries);
      if(data.status){
     var mapResult = JSON.parse(data.body);
       // for(var i = 0; i< registries.length; i++){
          $(".registry-data").html(mapResult);
       // }
        
      } 
     
  },
    error: function (error) {
    console.log(`Error ${error}`);
  }
  });
  
}

function showRegistriesData(response){
  //$(".registry-data").html(response);
}
function openRegistryList(){
  getAllCustomerRegistries();
   $(".registery-modal-popup-wrapper").show();
       $(".modal-overlay").show();
   /*$(".collection-data").html();
       $(".registery-modal-popup-wrapper").show();
       $(".modal-overlay").show();*/
}


function addGiftRegistry(){
  openRegistryList();
}
 $(document).ready(function() {
            $('table').each(function() {
                var $div = $('<div class="table-scroll"></div>');
                $(this).wrap($div);
            });
});

// Save the current state before navigating away
window.onbeforeunload = function() {
    history.replaceState({ prevUrl: document.referrer }, document.title);
}

// Check if the previous URL contains the word "collection" when navigating back
window.onpopstate = function(event) {
    if (event.state && event.state.prevUrl) {
        var prevUrl = event.state.prevUrl;
        if (prevUrl.includes('collections')) {
            $(".swym-registry-add-to-registry-success-modal-container #swym-registry-update-registry").attr("onclick","window.history.go(-1); return false");
        } 
    } 
};

// Example to manually add state
window.onload = function() {
    history.replaceState({ prevUrl: document.referrer }, document.title);
};


// Function to toggle .swym-drawer class on the body element
function toggleBodyClass() {
    if (document.querySelector('#swym-registry-gifter-modal-Sidenav .swym-registry-active')) {
        document.body.classList.add('swym-drawer');
    } else {
        document.body.classList.remove('swym-drawer');
    }
}

// Initial check in case .swym-registry-active is already present
toggleBodyClass();

// Create a MutationObserver to monitor changes in the DOM
var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
            toggleBodyClass();
        }
    });
});

// Set up the observer to watch the subtree of the target element
var target = document.getElementById('swym-registry-gifter-modal-Sidenav');
if (target) {
    observer.observe(target, { attributes: true, subtree: true });
}

